export default "<p>\n  reports-tab works!\n</p>\n";